import { Component, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

const noop = () => {};

@Component({
  selector: 'app-ep-input-form-field',
  templateUrl: './ep-input-form-field.component.html',
  styleUrls: ['./ep-input-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpInputFormFieldComponent),
      multi: true,
    },
  ],
})
export class EpInputFormFieldComponent implements ControlValueAccessor {
  @Input() isDisabled: boolean = false;
  @Input() errorMessage: string = '';
  @Input() isValid: boolean = true;
  @Input() placeholder: string = '';
  @Input() suffix: { icon: string; text: string } | undefined = undefined;
  @Output() inputBlur = new EventEmitter<string>();
  @ViewChild('epInput') epInput?: NgModel;

  private onChangeCallback: (value: string) => void = noop;
  private onTouchedCallback: () => void = noop;

  private _inputText: string = '';

  @Input()
  get inputText(): string {
    return this._inputText;
  }

  set inputText(value: string) {
    if (value !== this._inputText) {
      this._inputText = value;
      this.onChangeCallback(value);
    }
  }

  public handleInputBlur(value: string): void {
    this.onTouchedCallback();
    this.inputBlur.emit(value);
  }

  public markAsPristine(): void {
    this.epInput?.control.markAsPristine();
  }

  public writeValue(value: string): void {
    if (value !== this._inputText) {
      this._inputText = value;
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
